// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1qdQX","clinicsSelect":"TableHeading_clinicsSelect__y6G9R"};